<template>
  <div>
    <Movementmenu_govem />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดผู้ยืนย้าย (ประมวลผลแบบที่ 1)"
      >
        <v-card class="mb-4 pa-2">
          <v-simple-table>
            <tbody>
              <tr>
                <td class="text-center">
                  <v-btn
                    rounded
                    color="info"
                    :href="'#/admin/print_report_movement_online_2_govem/'"
                    target="_blank"
                    ><v-icon>mdi-printer</v-icon> พิมพ์รายงาน แบบที่ 1
                    (เพิ่มเติม)</v-btn
                  >
                </td>

                <td class="text-center">
                  <v-btn
                    rounded
                    color="info"
                    :href="'#/admin/print_report_movement_online_govem/'"
                    target="_blank"
                    ><v-icon>mdi-printer</v-icon> พิมพ์รายงาน แบบที่ 1
                    ข้อมูลดิบใช้พิจารณา</v-btn
                  >
                </td>
                <td class="text-center">
                  <v-btn
                    rounded
                    color="info"
                    :href="
                      '#/admin/print_report_condition_all/' +
                        periods.period_times +
                        '/' +
                        periods.period_year
                    "
                    target="_blank"
                    ><v-icon>mdi-printer</v-icon> พิมพ์รายงาน แบบที่ 2
                    แบบอัตราว่าง</v-btn
                  >
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  <v-btn
                    rounded
                    color="red"
                    @click="search_not_confirm_submit()"
                    ><v-icon>mdi-account-search</v-icon>
                    ไม่ได้บันทึกรายการ</v-btn
                  >
                </td>

                <td class="text-center">
                  <v-btn
                    @click="transference_locationUpdateQuery()"
                    rounded
                    color="warning"
                  >
                    <v-icon>mdi-alert</v-icon>
                    ปรับปรุงตำแหน่ง</v-btn
                  >
                </td>

                <td class="text-center">
                  <v-btn
                    rounded
                    color="info"
                    :href="
                      '#/admin/print_report_movement_formscore7/?period_times=' +
                        periods.period_times +
                        '&period_year=' +
                        periods.period_year
                    "
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon> แบบบันทึกผลคะแนน กลั่นกรอง
                    (7)</v-btn
                  >
                </td>

                <td class="text-center">
                  <v-btn
                    @click="exportGovEmRateExcel()"
                    :loading="exporting"
                    rounded
                    color="success"
                  >
                    <v-icon>mdi-microsoft-excel</v-icon> ส่งออกอัตราขาด/เกินเกณฑ์
                    (ต้นทาง-ปลายทาง)</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
        <v-select
          v-model="selectedHeaders"
          :items="headers"
          label="เลือกคอลัมน์ที่ต้องการแสดง"
          multiple
          outlined
          return-object
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 6">
              <span>{{ item.text }}</span>
            </v-chip>
            <span v-if="index === 6" class="grey--text caption"
              >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
            >
          </template>
        </v-select>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
          single-line
          hide-details
          dense
          filled
          class="mb-2"
        />

        <v-data-table
          :loading="loading"
          :headers="showHeaders"
          :items="transference_locations"
          :search="search"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td class="text-center">
                <v-checkbox
                  v-model="search_college"
                  :value="item.tlcollege_code"
                ></v-checkbox>
              </td>
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.id_cards }}</td>
              <td class="text-center">{{ item.title_s }}</td>
              <td class="text-center">{{ item.frist_name }}</td>
              <td class="text-center">{{ item.last_name }}</td>
              <td class="text-center bgtdNow">{{ item.college_code_now }}</td>
              <td class="text-center bgtdNow">{{ item.college_name_now }}</td>
              <td class="text-center bgtdNew">{{ item.tlcollege_code }}</td>
              <td class="text-center bgtdNew">
                <span style="font-size:16px;"> {{ item.tlsequence_n }}</span>
              </td>
              <td class="text-center bgtdNew">
                <span style="font-size:16px;"> {{ item.new_college }}</span>
              </td>
              <td class="text-center">
                {{ item.time_s + "/" + item.year_s }}
              </td>
              <td class="text-center">{{ item.age_app_time }}</td>
              <td class="text-center">{{ item.date_time }}</td>
              <td class="text-center">
                <v-chip
                  v-if="item.status_select === 'agree'"
                  color="warning"
                  dark
                >
                  <span style="font-size:16px;">ปกติ (2)</span>
                </v-chip>
                <v-chip
                  v-else-if="item.status_select === 'sw_normal'"
                  color="warning"
                  dark
                >
                  <span style="font-size:16px;">สับเปลี่ยน (3)</span>
                </v-chip>
                <v-chip
                  v-else-if="item.status_select === 'sw_agree'"
                  color="warning"
                  dark
                >
                  <span style="font-size:16px;">แลกเปลี่ยน (4)</span>
                </v-chip>
                <v-icon
                  v-else-if="item.succ_college >= 1"
                  color="red"
                  large
                  @click.stop="deletePosition(item.id_ref)"
                  >mdi-delete-circle</v-icon
                >
                <v-icon
                  v-else
                  color="yellow"
                  large
                  @click.stop="select_idPosition(item.id_ref, item.id_tfl)"
                  >mdi-credit-card-plus</v-icon
                >
              </td>
              <td class="text-center">
                <v-chip :color="getColor(item.succ_college)" dark>
                  <span style="font-size:16px;"> {{ item.succ_college }}</span>
                </v-chip>
              </td>
              <td class="text-center">
                <v-chip :color="getColor(item.succ_college)" dark>
                  <span style="font-size:16px;">
                    <v-chip v-if="item.college_name_suss === ''"> </v-chip>
                    <v-chip
                      v-else-if="item.college_name_suss !== ''"
                      color="green"
                      dark
                    >
                      <span style="font-size:16px;">
                        {{ item.college_name_suss }}</span
                      >
                    </v-chip>
                  </span>
                </v-chip>
              </td>
              <td class="text-center">{{ item.id_position_new }}</td>
              <td class="text-center">
                <v-chip
                  v-if="item.gov_position_open_for_transfer == 1"
                  color="success"
                  dark
                  small
                >
                  <v-icon left small>mdi-check-circle</v-icon>เปิดรับย้าย
                </v-chip>
                <v-tooltip v-else top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip color="grey" dark small v-bind="attrs" v-on="on">
                      <v-icon left small>mdi-alert-circle-outline</v-icon
                      >ไม่พบประกาศเปิด
                    </v-chip>
                  </template>
                  <span
                    >สถานศึกษาปลายทางยังไม่ได้ประกาศเปิดรับย้ายตำแหน่งนี้ใน
                    college_manpower
                    (หรือยังไม่ยืนยันเลขที่ตำแหน่งปลายทาง)</span
                  >
                </v-tooltip>
              </td>
              <td class="text-center">
                <div class="d-flex flex-column" style="gap:4px;">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        :color="rateColor(item.teach_rate_diff)"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        ครู {{ item.teach_rate_actual }}/{{
                          item.teach_rate_criterion
                        }}
                        ({{ item.teach_rate_diff > 0 ? "+" : ""
                        }}{{ item.teach_rate_diff }})
                      </v-chip>
                    </template>
                    <span>{{ rateTooltip("ข้าราชการครู (ปลายทาง)", item.gov_rate_year, item.teach_rate_actual, item.teach_rate_criterion, item.teach_rate_diff) }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        :color="rateColor(item.gov_rate_diff)"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        พรก. {{ item.gov_rate_actual }}/{{
                          item.gov_rate_criterion
                        }}
                        ({{ item.gov_rate_diff > 0 ? "+" : ""
                        }}{{ item.gov_rate_diff }})
                      </v-chip>
                    </template>
                    <span>{{ rateTooltip("พนักงานราชการ (ปลายทาง)", item.gov_rate_year, item.gov_rate_actual, item.gov_rate_criterion, item.gov_rate_diff) }}</span>
                  </v-tooltip>
                </div>
              </td>
              <td class="text-center">
                <div class="d-flex flex-column" style="gap:4px;">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        :color="rateColor(item.teach_rate_origin_diff)"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        ครู {{ item.teach_rate_origin_actual }}/{{
                          item.teach_rate_origin_criterion
                        }}
                        ({{ item.teach_rate_origin_diff > 0 ? "+" : ""
                        }}{{ item.teach_rate_origin_diff }})
                      </v-chip>
                    </template>
                    <span>{{ rateTooltip("ข้าราชการครู (ต้นทาง)", item.gov_rate_origin_year, item.teach_rate_origin_actual, item.teach_rate_origin_criterion, item.teach_rate_origin_diff) }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        :color="rateColor(item.gov_rate_origin_diff)"
                        dark
                        x-small
                        v-bind="attrs"
                        v-on="on"
                      >
                        พรก. {{ item.gov_rate_origin_actual }}/{{
                          item.gov_rate_origin_criterion
                        }}
                        ({{ item.gov_rate_origin_diff > 0 ? "+" : ""
                        }}{{ item.gov_rate_origin_diff }})
                      </v-chip>
                    </template>
                    <span>{{ rateTooltip("พนักงานราชการ (ต้นทาง)", item.gov_rate_origin_year, item.gov_rate_origin_actual, item.gov_rate_origin_criterion, item.gov_rate_origin_diff) }}</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>

          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!-- V-model positiondialog -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="เลือกตำแหน่ง"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <h3>
                        รหัสอ้างอิง :
                        {{ transference_personnels_id_ref.id_ref }}
                      </h3>
                      รหัสบัตรประชาชน :
                      {{ transference_personnels_id_ref.id_card }}
                      <h3>
                        ชื่อ-นามสกุล :
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}
                        สถานศึกษาปัจจุบัน :
                        {{ transference_personnels_id_ref.college_code }}
                        {{ transference_personnels_id_ref.college_name }}
                        เลขที่ตำแหน่งปัจจุบัน :
                        {{ transference_personnels_id_ref.id_position }}
                      </h3>
                      <h4>
                        ย้ายครั้งที่ : {{ periods.period_times }} ปี :
                        {{
                          periods.period_year
                            | moment("add", "543 years")
                            | moment("YYYY")
                        }}
                      </h4>
                      <h4>
                        รอบการย้าย :
                        {{
                          periods.period_start
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                        -
                        {{
                          periods.period_stop
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </h4>
                      <h4>
                        คำนวณอายุงาน ณ สถานศึกษาปัจจุบัน โดยใช้วันที่ :
                        {{
                          periods.period_cal_end
                            | moment("add", "543 years")
                            | moment("D MMMM YYYY")
                        }}
                      </h4>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <h2>
                          เหตุผลในการย้าย :
                        </h2>

                        <div
                          v-if="transference_personnels_id_ref.reason_1 === '1' || transference_personnels_id_ref.reason_1 === 1"
                        >
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายเพื่ออยู่ร่วมคู่สมรส</h3>
                            <h4>
                              คู่สมรสชื่อ :
                              {{
                                transference_personnels_id_ref.reason_1_spouse ||
                                  "-"
                              }}
                              คู่สมรสประกอบอาชีพ :
                              {{
                                transference_personnels_id_ref.reason_1_occupation ||
                                  "-"
                              }}
                              สถานที่ประกอบอาชีพของคู่สมรส :
                              {{
                                transference_personnels_id_ref.reason_1_location ||
                                  "-"
                              }}
                              ภูมิลำเนาของคู่สมรส จังหวัด
                              {{ transference_personnels_id_ref.r1_province }}
                            </h4>
                          </v-alert>
                        </div>

                        <div
                          v-if="transference_personnels_id_ref.reason_2 === '1' || transference_personnels_id_ref.reason_2 === 1"
                        >
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายเพื่ออยู่ดูแลบิดา มารดา</h3>
                            <h4>
                              อายุของบิดา :
                              {{
                                transference_personnels_id_ref.reason_2_fyear ||
                                  "-"
                              }}
                              ปี อายุของมารดา :
                              {{
                                transference_personnels_id_ref.reason_2_myear ||
                                  "-"
                              }}
                              ปี ภูมิลำเนาของบิดา มารดา จังหวัด :
                              {{ transference_personnels_id_ref.r2_province }}
                            </h4>
                          </v-alert>
                        </div>
                        <div
                          v-if="transference_personnels_id_ref.reason_3 === '1' || transference_personnels_id_ref.reason_3 === 1"
                        >
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>ย้ายกลับภูมิลำเนา</h3>

                            <h4>
                              จังหวัด :
                              {{ transference_personnels_id_ref.r3_province }}
                            </h4>
                          </v-alert>
                        </div>
                        <div
                          v-if="transference_personnels_id_ref.reason_4 === '1' || transference_personnels_id_ref.reason_4 === 1"
                        >
                          <v-alert
                            border="left"
                            colored-border
                            type="info"
                            elevation="2"
                          >
                            <h3>
                              เหตุผลอื่น ๆ :
                            </h3>
                            <h4>
                              {{
                                transference_personnels_id_ref.reason_4_detail
                              }}
                            </h4>
                          </v-alert>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="12">
                    <v-card elevation="2" class="pa-2">
                      <v-flex md12>
                        <div class="text-center">
                          <h2>
                            {{ transference_location_s.id_branch_s }}
                            สาขาวิชาเอก :
                            {{ transference_location_s.name_branch }}
                          </h2>

                          <h2>
                            {{ transference_location_s.tlcollege_code }}
                            {{ transference_location_s.college_name }}
                          </h2>
                        </div>
                      </v-flex>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-card elevation="2" class="pa-2">
                      <v-flex md12>
                        <v-autocomplete
                          prepend-icon="mdi-account-details"
                          :items="man_powers"
                          item-text="college_position_case"
                          item-value="id_position"
                          label="เลขที่ตำแหน่ง"
                          v-model="updatepositions.id_position"
                          outlined
                          required
                          :rules="[v => !!v || '']"
                        ></v-autocomplete>
                      </v-flex>
                    </v-card>
                  </v-col>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn
                large
                color="green"
                @click.stop="updatepositionSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model canceldialog -->
      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="ยกเลิกรายการ"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <h3>
                        รหัสอ้างอิง :
                        {{ transference_personnels_id_ref.id_ref }}
                      </h3>

                      <div class="text--center">
                        รหัสบัตรประชาชน :
                        {{ transference_personnels_id_ref.id_card }}
                        <h3>
                          ชื่อ-นามสกุล :
                          {{ transference_personnels_id_ref.title_s
                          }}{{ transference_personnels_id_ref.frist_name }}
                          {{ transference_personnels_id_ref.last_name }}
                        </h3>

                        สถานศึกษาปัจจุบัน :
                        {{ transference_personnels_id_ref.college_name }}
                        เลขที่ตำแหน่งปัจจุบัน :
                        {{ transference_personnels_id_ref.id_position }}
                      </div>
                    </v-flex>
                    <v-flex md6>
                      <h3>
                        รหัสวิทยาลัยปลายทาง :
                        {{ man_powerss.college_code || "สับเปลี่ยนตำแหน่ง" }}
                      </h3>
                      <div>
                        วิทยาลัย :
                        {{ man_powerss.college_name || "สับเปลี่ยนตำแหน่ง" }}
                      </div>
                      เลขที่ตำแหน่ง :
                      {{ man_powerss.id_position || "สับเปลี่ยนตำแหน่ง" }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="canceldialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>
              <v-btn large color="warning" @click.stop="cancelSubmit()" rounded>
                <v-icon dark>mdi-pencil</v-icon>&nbsp;ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Movementmenu_govem from "../../../components/admin/movementmenu_govem.vue";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      value: "1",
      loading: false,
      exporting: false,
      ApiKey: "HRvec2021",
      branch_s: [],
      id_ref: [],
      valid: true,
      canceldialog: false,
      positiondialog: false,
      clear_dataDialog: false,
      times_select: "",
      years_select: "",
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      transference_locations: [],
      edittransference_location: {},
      search: "",
      search_college: "",
      pagination: {},
      singleSelect: false,
      selected: [],
      headers: [],
      selectedHeaders: [],
      headersMap: [
        /*  { text: "อ้างอิง", align: "center", value: "id_ref" }, */
        { text: "เลือก", align: "left", value: "select_item" },
        { text: "#", align: "center", value: "index" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "id_card" },
        { text: "คำนำหน้า", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ส.ปัจจุบัน", align: "center", value: "college_code_now" },
        { text: "ส.ปัจจุบัน", align: "center", value: "college_name_now" },
        { text: "ส.แห่งใหม่", align: "center", value: "tlcollege_code" },
        { text: "ลำดับ", align: "center", value: "tlsequence_n" },
        { text: "ส.แห่งใหม่", align: "center", value: "college_name" },
        { text: "ครั้งที่/ปี", align: "center", value: "time_ys" },
        { text: "อายุงาน", align: "center", value: "age_app_time" },
        { text: "วันที่", align: "center", value: "date_time" },
        { text: "ย้ายแบบที่ 1", align: "center", value: "actions" },
        { text: "แห่งใหม่ ส.", align: "center", value: "succ_college" },
        {
          text: "วิทยาลัยแห่งใหม่",
          align: "center",
          value: "college_name_suss"
        },
        { text: "เลขที่", align: "center", value: "id_position_new" },
        {
          text: "สถานะเปิดรับ (สถานศึกษา)",
          align: "center",
          value: "gov_position_open_for_transfer"
        },
        {
          text: "อัตรากำลัง ครู/พรก. (ปลายทาง)",
          align: "center",
          value: "gov_rate_diff"
        },
        {
          text: "อัตรากำลัง ครู/พรก. (ต้นทาง)",
          align: "center",
          value: "gov_rate_origin_diff"
        }
      ],
      header_trans: [
        { text: "ลำดับ", align: "center", value: "tlsequence_n" },
        { text: "รหัสอ้างอิง", align: "center", value: "id_ref" },
        { text: "สาขาวิชา", align: "center", value: "name_branch" },
        { text: "วิทยาลัย", align: "center", value: "college_name" }
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      transference_locationstatus: [],
      transference_locations_id_ref: [],
      conditons_transfer_successs: [],
      updatepositions_condition: {},
      conditons_transfer_success_del: [],
      man_powers: [],
      userstatus: {},
      updatepositions: {},
      man_powerss: [],
      colleges: [],
      data_select: [],
      provinces: [],
      regions: [],
      transference_personnels_id_ref: [],
      period_times: [],
      periods: [],
      transference_location_s: [],
      periods: [],
      period_enable_process: "1",
      addreturn_man_power: {},
      man_power_cancel: {}
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  async mounted() {
    let result_branch;
    result_branch = await this.$http.post("branch.php", {
      ApiKey: this.ApiKey
    });
    this.branch_s = result_branch.data;
    let result;
    result = await this.$http.post("collegetype.php", {
      ApiKey: this.ApiKey
    });
    this.collegetypes = result.data;
    result = await this.$http.post("college.php", {
      ApiKey: this.ApiKey
    });
    this.colleges = result.data;
    result = await this.$http.post("province.php", {
      ApiKey: this.ApiKey
    });
    this.provinces = result.data;
    result = await this.$http.post("region.php", {
      ApiKey: this.ApiKey
    });
    this.regions = result.data;
    await this.periodQuery();
    await this.transference_locationQueryAll();
    this.man_powerQuery();
  },
  methods: {
    exportGovEmRateExcel() {
      this.exporting = true;
      try {
        const rateStatus = diff =>
          diff > 0 ? "เกินเกณฑ์" : diff < 0 ? "ขาดเกณฑ์" : "พอดีเกณฑ์";

        const dataToExport = this.transference_locations.map(item => ({
          "เลขบัตรประชาชน": item.id_cards,
          "ชื่อ-สกุล": `${item.title_s || ""}${item.frist_name || ""} ${item.last_name || ""}`,
          "สาขาที่ขอย้าย": item.name_branch,
          "รหัสต้นทาง": item.college_code_now,
          "สถานศึกษาต้นทาง": item.college_name_now,
          "รหัสปลายทาง": item.tlcollege_code,
          "สถานศึกษาปลายทาง": item.new_college,
          "สถานะเปิดรับปลายทาง":
            item.gov_position_open_for_transfer == 1
              ? "เปิดรับย้าย"
              : "ไม่พบประกาศเปิด",
          "ครู ต้นทาง (ตัวจริง)": item.teach_rate_origin_actual,
          "ครู ต้นทาง (เกณฑ์)": item.teach_rate_origin_criterion,
          "ครู ต้นทาง (ผลต่าง)": item.teach_rate_origin_diff,
          "ครู ต้นทาง (สถานะ)": rateStatus(item.teach_rate_origin_diff),
          "พรก. ต้นทาง (ตัวจริง)": item.gov_rate_origin_actual,
          "พรก. ต้นทาง (เกณฑ์)": item.gov_rate_origin_criterion,
          "พรก. ต้นทาง (ผลต่าง)": item.gov_rate_origin_diff,
          "พรก. ต้นทาง (สถานะ)": rateStatus(item.gov_rate_origin_diff),
          "ครู ปลายทาง (ตัวจริง)": item.teach_rate_actual,
          "ครู ปลายทาง (เกณฑ์)": item.teach_rate_criterion,
          "ครู ปลายทาง (ผลต่าง)": item.teach_rate_diff,
          "ครู ปลายทาง (สถานะ)": rateStatus(item.teach_rate_diff),
          "พรก. ปลายทาง (ตัวจริง)": item.gov_rate_actual,
          "พรก. ปลายทาง (เกณฑ์)": item.gov_rate_criterion,
          "พรก. ปลายทาง (ผลต่าง)": item.gov_rate_diff,
          "พรก. ปลายทาง (สถานะ)": rateStatus(item.gov_rate_diff),
          "ปี rate_work_g ต้นทาง": item.gov_rate_origin_year,
          "ปี rate_work_g ปลายทาง": item.gov_rate_year
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "อัตราขาดเกินเกณฑ์ พรก.");
        const now = new Date();
        const yy = now.getFullYear() + 543;
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");
        XLSX.writeFile(
          wb,
          `อัตรากำลังพรก_ต้นทาง_ปลายทาง_${yy}${mm}${dd}.xlsx`
        );
      } catch {
        Swal.fire({
          icon: "error",
          title: "ส่งออกไฟล์ไม่สำเร็จ กรุณาลองใหม่",
          showConfirmButton: false,
          timer: 1500
        });
      } finally {
        this.exporting = false;
      }
    },
    async transference_locationUpdateQuery() {
      try {
        this.loading = true;
        let result = await this.$http.post(
          "transference_location.update_govem_donot_teach.php",
          {
            ApiKey: this.ApiKey
          }
        );
        if (result.data.status == true) {
          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_id: "401"
      });
      this.periods = result_period.data;
    },

    async search_not_confirm_submit() {
      this.loading = true;
      let result = await this.$http
        .post("transference_location_detail.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          id_ref_s: "gov_"
        })
        .finally(() => (this.loading = false));
      this.transference_locations = result.data;
    },
    async transference_locationQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_location_detail.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          id_ref_s: "gov_"
        })
        .finally(() => (this.loading = false));
      this.transference_locations = result.data;
    },
    async select_idPosition(id_ref, id_tfl) {
      let result_con = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;
      let result = await this.$http.post("transference_location.php", {
        ApiKey: this.ApiKey,
        id_tfl: id_tfl
      });
      this.transference_location_s = result.data;
      this.updatepositions = {};
      this.man_powerQuery();
      this.positiondialog = true;
    },
    async man_powerQuery() {
      let man_power_result;
      man_power_result = await this.$http.post("government_employee.php", {
        ApiKey: this.ApiKey,
        college_code: this.transference_location_s.tlcollege_code,
        id_card_null: "ok"
      });
      this.man_powers = man_power_result.data;
    },
    /// updatepositionSubmit
    async updatepositionSubmit() {
      if (this.$refs.updatepositionform.validate()) {
        this.updatepositions.ApiKey = this.ApiKey;
        this.updatepositions.time_s = this.transference_personnels_id_ref.time_ss;
        this.updatepositions.year_s = this.transference_personnels_id_ref.year_ss;
        this.updatepositions.college_code_old = this.transference_personnels_id_ref.college_code;
        this.updatepositions.id_postion_old = this.transference_personnels_id_ref.id_position;
        this.updatepositions.id_card = this.transference_personnels_id_ref.id_card;
        this.updatepositions.id_ref = this.transference_personnels_id_ref.id_ref;
        this.updatepositions.college_code = this.transference_location_s.tlcollege_code;
        this.updatepositions.id_branch = this.transference_location_s.id_branch_s;
        this.updatepositions.status_select = "demand";

        let result = await this.$http.post(
          "conditons_transfer_success.insert.php",
          this.updatepositions
        );

        if (result.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "บันทึกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.transference_locationQueryAll();
        } else {
          Swal.fire({
            icon: "warning",
            title: "ดำเนินการผิดพลาด",
            showConfirmButton: false,
            timer: 1500
          });
        }
        this.positiondialog = false;
      }
    },
    async deletePosition(id_ref) {
      let result_con = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;
      let result_man = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_personnels_id_ref.id_card
      });
      this.man_powerss = result_man.data;
      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });
      this.conditons_transfer_successs = result_cts.data;
      this.canceldialog = true;
    },
    async cancelSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.man_powerss.ApiKey = this.ApiKey;
        this.man_powerss.status_booking = "";
        this.conditons_transfer_successs.ApiKey = this.ApiKey;
        this.man_power_cancel.ApiKey = this.ApiKey;
        this.man_power_cancel.id_position = this.conditons_transfer_successs.id_postion_old;

        let result_man = await this.$http.post(
          "man_power.update_process.php",
          this.man_powerss
        );
        let result_man_delete = await this.$http.post(
          "man_power.delete.php",
          this.man_power_cancel
        );
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successs
        );
        if (
          result_man.data.status == true &&
          result_cts.data.status == true &&
          result_man_delete.data.status == true
        ) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.transference_locationQueryAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
        this.canceldialog = false;
      }
    },
    getColor() {
      /*  if (calories > 400) return 'red'
              else if (calories > 200) return 'orange'
              else return 'green'  */
      return "green";
    },
    rateColor(diff) {
      if (diff > 0) return "orange";
      if (diff < 0) return "red";
      return "success";
    },
    rateTooltip(label, year, actual, criterion, diff) {
      const status =
        diff > 0
          ? "เกินเกณฑ์ " + diff + " คน"
          : diff < 0
          ? "ขาดเกณฑ์ " + Math.abs(diff) + " คน"
          : "พอดีเกณฑ์";
      return (
        "เกณฑ์อัตรากำลัง" +
        label +
        " (rate_work_g ปี " +
        (year || "-") +
        "): ตัวจริง " +
        actual +
        " คน / เกณฑ์ " +
        criterion +
        " คน — " +
        status
      );
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    color() {
      return "cyan darken-3";
    },
    period_years() {
      let yyyy = this.periods.period_year;
      return yyyy;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  },
  components: { Movementmenu_govem }
};
</script>

<style scoped>
.bgtdNow {
  background-color: rgb(209, 207, 207);
}
.bgtdNew {
  background-color: rgb(125, 229, 247);
}
</style>
